const getOrderLineDescription = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    return indexOrderLine ? indexOrderLine.Description : null;
  }
  return orderLine
    ? orderLine.map(item => item.Description).join(', ')
    : null;
};

export default getOrderLineDescription;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDescription.js